import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserLayoutComponent } from './user-layout.component';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { KSideMenuModule } from 'app/common/ui/k-side-menu/k-side-menu.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BalancesItemModule } from 'app/common/components/balances-item/balances-item.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { KCardContentModule } from 'app/common/ui/k-card-content/k-card-content.module';
import { DirectivesModule } from 'app/common/directives/directives.module';
import { QuickPurchaseModule } from 'app/common/components/quick-purchase/quick-purchase.module';
// import { LanguageSwitchModule } from 'app/common/components/language-switch/language-switch.module';
import { ToastModule } from 'primeng/toast';
import { NotificationsModule } from 'app/common/components/notifications/notifications.module';
import { TooltipModule } from 'primeng/tooltip';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';


@NgModule({
  declarations: [
    UserLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    KSideMenuModule,
    BrowserAnimationsModule,
    BalancesItemModule,
    FontAwesomeModule,
    KCardContentModule,
    DirectivesModule,
    QuickPurchaseModule,
    // LanguageSwitchModule,
    ToastModule,
    NotificationsModule,
    TooltipModule,
    KButtonModule
  ],
  exports: [
    UserLayoutComponent
  ]
})
export class UserLayoutModule { }
